import { VStack } from "@chakra-ui/react"
import React from "react"
import { GenerateSummarizedUserAttendanceReportForm } from "../../../forms"

export const GenerateSummarizedUserAttendanceReport: React.FC = () => {
	return (
		<VStack w="full" spacing={6}>
			<GenerateSummarizedUserAttendanceReportForm />
		</VStack>
	)
}
